import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	.save-button {
		.button {
			padding: 0;
		}

		.button-icon-before {
			width: 2em;
		}

		.button-icon-before-hover {
			width: 2em;
		}

		&:hover {
			.button-content {
				text-decoration: underline;
			}
		}
	}

	&.disabled {
		pointer-events: none;

		.save-button {
			.button {
				background-color: transparent !important;

				.button-icon-image {
					filter: invert(78%) sepia(3%) saturate(0%) hue-rotate(183deg)
						brightness(102%) contrast(86%);
				}
				.button-content {
					background-color: transparent;
					color: ${vars.colorTextLighter};
				}
			}
		}
	}

	.public-layout-modals-job-login-modal {
		.layout-modal {
			.modal-container {
				top: 56%;
				padding: 1.3em 2em 1em 2em;

				.google-recaptcha {
					padding: 0;
					margin: 0 0 1em 0;
				}

				.public-layout-forms-form-footer {
					display: flex;
					flex-flow: row wrap;
					gap: 1em;

					.footer-title {
						margin-top: 1em;
						width: 100%;
					}

					.layout-google-login,
					.layout-facebook-login {
						width: calc(50% - 1em);

						.button {
							.button-content {
								display: none;
							}
						}
					}
					.footer {
						margin: 0 auto;
						padding: 0;
					}
				}
			}
		}
	}

	@media all and (max-width: ${vars.mobileL}) {
		.button {
			.button-content {
				display: none;
			}
		}

		.public-layout-modals-job-login-modal {
			.layout-modal {
				.modal-container {
					top: 9%;
					padding: 1.3em 2em 1em 2em;
				}
			}
		}
	}
`;
